import React, { useEffect, useRef, useState } from 'react';
import { skillsData } from '../data/mock';
import { ShieldCheck, Brain, Lock, Cpu } from 'lucide-react';

const categoryIcons = {
  'Cyber Defense': ShieldCheck,
  'Architecture & Strategy': Lock,
  'Governance & Risk': Brain,
  'AI & Innovation': Cpu,
};

function useInView(ref) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [ref]);
  return visible;
}

export default function SkillsSection() {
  const sectionRef = useRef(null);
  const visible = useInView(sectionRef);

  return (
    <section id="skills" className="relative" ref={sectionRef}>
      <div className="section-container">
        <div className={`fade-in-up ${visible ? 'visible' : ''}`}>
          <p className="section-label">// Technical Arsenal</p>
          <h2 className="section-title">Skills & Expertise</h2>
          <div className="glow-line w-20 mb-12" />
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {skillsData.map((cat, catIdx) => {
            const Icon = categoryIcons[cat.category] || ShieldCheck;
            return (
              <div
                key={cat.category}
                className={`cyber-card p-6 fade-in-up ${visible ? 'visible' : ''}`}
                style={{ transitionDelay: `${0.1 + catIdx * 0.15}s` }}
              >
                {/* Category header */}
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-10 h-10 rounded-lg bg-[#00e5ff]/8 border border-[#00e5ff]/20 flex items-center justify-center">
                    <Icon className="w-5 h-5 text-[#00e5ff]" />
                  </div>
                  <h3 className="font-semibold text-[#f1f5f9] text-base">{cat.category}</h3>
                </div>

                {/* Skills */}
                <div className="space-y-5">
                  {cat.skills.map((skill) => (
                    <div key={skill.name}>
                      <div className="flex items-center justify-between mb-2">
                        <span className="text-sm text-[#c8d1dc]">{skill.name}</span>
                        <span className="font-['JetBrains_Mono'] text-xs text-[#00e5ff]">{skill.level}%</span>
                      </div>
                      <div className="skill-bar-track">
                        <div
                          className="skill-bar-fill"
                          style={{ width: visible ? `${skill.level}%` : '0%' }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
